import React, { FC, PropsWithChildren } from 'react';
import { SkipNavLink, SkipNavContent, SkipNavLinkProps } from '@chakra-ui/skip-nav';

interface Props extends SkipNavLinkProps {
  text: string;
}

const Link: FC<Props> = ({ text, ...rest }) => {
  /**
   * DOM
   */
  return (
    <SkipNavLink {...rest} data-object-type="skip-nav-link">
      {text}
    </SkipNavLink>
  );
};

const Content: FC<PropsWithChildren> = ({ children }) => {
  /**
   * DOM
   */
  return (
    <>
      <SkipNavContent data-object-type="skip-nav-content"></SkipNavContent>
      <>{children}</>
    </>
  );
};

export const SkipNav = {
  Link,
  Content,
};
